import { ConvertMillimetersToCentimeters, ConvertCentimetersToMillimeters } from '@/utils/converters';
import request from '@/utils/request';

function transformItem2Dto(item) {
  const dto = {
    ...item,
    linkDomainProductGroupID: item.id,
    defaultSideFinishMeasurementInMm: ConvertCentimetersToMillimeters(item.defaultSideFinishMeasurementInCm),
    defaultBottomFinishMeasurementInMm: ConvertCentimetersToMillimeters(item.defaultBottomFinishMeasurementInCm),
    defaultLiningBottomFinishMeasurementInMm: ConvertCentimetersToMillimeters(
      item.defaultLiningBottomFinishMeasurementInCm
    ),
    minimumWidthInMm: ConvertCentimetersToMillimeters(item.minimumWidthInCm),
    maximumWidthInMm: ConvertCentimetersToMillimeters(item.maximumWidthInCm),
    maximumLinedWidthInMm: ConvertCentimetersToMillimeters(item.maximumLinedWidthInCm),
    maximumFabricWidthInMm: ConvertCentimetersToMillimeters(item.maximumFabricWidthInCm),
    maximumLinedFabricWidthInMm: ConvertCentimetersToMillimeters(item.maximumLinedFabricWidthInCm),
    minimumHeightInMm: ConvertCentimetersToMillimeters(item.minimumHeightInCm),
    maximumHeightInMm: ConvertCentimetersToMillimeters(item.maximumHeightInCm),
    maximumLinedHeightInMm: ConvertCentimetersToMillimeters(item.maximumLinedHeightInCm)
  };
  delete dto.id;
  delete dto.defaultSideFinishMeasurementInCm;
  delete dto.defaultBottomFinishMeasurementInCm;
  delete dto.defaultLiningBottomFinishMeasurementInCm;
  delete dto.minimumWidthInCm;
  delete dto.maximumWidthInCm;
  delete dto.maximumLinedWidthInCm;
  delete dto.maximumFabricWidthInCm;
  delete dto.maximumLinedFabricWidthInCm;
  delete dto.minimumHeightInCm;
  delete dto.maximumHeightInCm;
  delete dto.maximumLinedHeightInCm;
  return dto;
}

function transformDto2Item(dto) {
  const item = {
    ...dto,
    id: dto.linkDomainProductGroupID,
    defaultSideFinishMeasurementInCm: ConvertMillimetersToCentimeters(dto.defaultSideFinishMeasurementInMm),
    defaultBottomFinishMeasurementInCm: ConvertMillimetersToCentimeters(dto.defaultBottomFinishMeasurementInMm),
    defaultLiningBottomFinishMeasurementInCm: ConvertMillimetersToCentimeters(
      dto.defaultLiningBottomFinishMeasurementInMm
    ),
    minimumWidthInCm: ConvertMillimetersToCentimeters(dto.minimumWidthInMm),
    maximumWidthInCm: ConvertMillimetersToCentimeters(dto.maximumWidthInMm),
    maximumLinedWidthInCm: ConvertMillimetersToCentimeters(dto.maximumLinedWidthInMm),
    maximumFabricWidthInCm: ConvertMillimetersToCentimeters(dto.maximumFabricWidthInMm),
    maximumLinedFabricWidthInCm: ConvertMillimetersToCentimeters(dto.maximumLinedFabricWidthInMm),
    minimumHeightInCm: ConvertMillimetersToCentimeters(dto.minimumHeightInMm),
    maximumHeightInCm: ConvertMillimetersToCentimeters(dto.maximumHeightInMm),
    maximumLinedHeightInCm: ConvertMillimetersToCentimeters(dto.maximumLinedHeightInMm)
  };
  delete item.linkDomainProductGroupID;
  delete item.defaultSideFinishMeasurementInMm;
  delete item.defaultBottomFinishMeasurementInMm;
  delete item.minimumWidthInMm;
  delete item.maximumWidthInMm;
  delete item.maximumLinedWidthInMm;
  delete item.maximumFabricWidthInMm;
  delete item.maximumLinedFabricWidthInMm;
  delete item.minimumHeightInMm;
  delete item.maximumHeightInMm;
  delete item.maximumLinedHeightInMm;

  return item;
}

function apiItemByDomainAndProductGroup(domainID, productGroupID) {
  return request({
    method: 'get',
    url: `/linkdomainproductgroup/${domainID}/${productGroupID}`
  });
}

function getParcelType(domainID, productGroupID) {
  return request({
    method: 'get',
    url: `/linkdomainproductgroup/domain/${domainID}/productgroup/${productGroupID}/parceltype`
  });
}

export const storeExtensions = {
  actions: {
    getItemByDomainAndProductGroup({ dispatch }, { domainID, productGroupID } = {}) {
      return apiItemByDomainAndProductGroup(domainID, productGroupID).then(response => {
        return transformDto2Item(response.data);
      });
    },
    getParcelType({ dispatch }, { domainID, productGroupID } = {}) {
      return getParcelType(domainID, productGroupID).then(response => {
        return response.data;
      });
    }
  }
};

export const apiOverrides = { transformItem2Dto, transformDto2Item };
